document.addEventListener('click', function (e) {
  const btn = e.target.closest('.wishlist-btn');
  if (!btn) return;

  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  const handle = btn.dataset.productHandle;

  if (!wishlist.includes(handle)) {
    wishlist.push(handle);
    btn.innerHTML = '❤️ Wishlisted';
  } else {
    wishlist = wishlist.filter(item => item !== handle);
    btn.innerHTML = '❤️ Add to wishlist';
  }

  localStorage.setItem('wishlist', JSON.stringify(wishlist));
});
